module.exports = "/assets/bfd9964bac9dda3d9ab5f8812adc9ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/R2.png
// module id = 1772
// module chunks = 0